













































































import { defineComponent, reactive, toRefs, computed, ref, onMounted, onBeforeUnmount } from '@vue/composition-api';
import * as Common from "../../commons/common"
import moment from 'moment';
import http from "../../plugins/http";
import SumupTab from "../../components/SumupTab.vue";
import AlertArea from "../../components/AlertArea.vue";
import { Sheet, RowItem } from '../../modules/teacher/SumupQuestionScoreRateList';

export interface Data {
  tabNo: number
  sheet_group_key: string
  subject_id: string
  sheet: Sheet | null
  roomNames: string[]
  rowItems: RowItem[]
  SheetTypeEnum: Readonly<{Normal: number; Cbt: number; Entrance: number}>
  errors: string[]
}

export default defineComponent({
  components: {
    "sumup-tab": SumupTab,
    "alert-area": AlertArea,
  },
  setup(props, context){

    /************************************************************
     * data
     ************************************************************/

    const state = reactive<Data>({
      tabNo: 4,
      sheet_group_key: "",
      subject_id: "",
      sheet: null,
      roomNames: new Array<string>(),
      rowItems: new Array<RowItem>(),
      SheetTypeEnum: Common.SheetTypeEnum,
      errors: [],
    });

    /************************************************************
     * グラフのclass取得
     ************************************************************/

    const getGraphClass = (idx: number, roomRate: number, totalRate: number) => {
      if(idx == 2){
        return {yoda: true};
      }else if(totalRate > roomRate + 10){
        return {pink: true};
      }else if(totalRate < roomRate - 10 ){
        return {obi: true};
      }else{
        return {yoda: true};
      }
    };

    /************************************************************
     * mounted
     ************************************************************/
    
    onMounted(async () => {
      context.root.$store.dispatch("showOverlay", "データ取得中... しばらくお待ちください。");
      state.sheet_group_key = context.root.$route.params.sheet_group_key;
      state.subject_id = context.root.$route.params.subject_id;
      await http.get(`/api/sumup_question_score_rate_list?sheet_group_key=${state.sheet_group_key}&subject_id=${state.subject_id}`).then(response => {
        
        state.sheet = new Sheet(response.data.sheet);
        const all_score_rates = response.data.score_rates;
        if(all_score_rates.length > 0){
          const roomNames: string[] = Array.from(new Set(all_score_rates[0].map((x: any) => x.room_name)));
          state.roomNames.push("全体");
          state.roomNames = state.roomNames.concat(roomNames);

          all_score_rates.forEach((corect_rates: any[]) => {
            state.rowItems.push(new RowItem(corect_rates));
          });
        }
      })
      .catch(error=>{
        // 後続処理不能のため一覧に戻る
        if(error.response.status == 422){
          alert(`試験情報の取得処理に失敗しました。試験一覧に戻ります。\n${error.response.data.errors[0]}`);
        }else{
          alert(`試験情報の取得処理に失敗しました。試験一覧に戻ります。`);
        }
        context.root.$store.dispatch("goSheetList");
      });
      context.root.$store.dispatch("hideOverlay");
    });

    return {
      ...toRefs(state),
      getGraphClass,
    };
  }
});

